import { saveAs } from "file-saver";
var download = function download(url, name) {
  return saveAs(url, name);
};
export default download;